export var GuardTypes = Object.freeze({
  CONTINUE: 'CONTINUE',
  ABORT: 'ABORT',
  REDIRECT: 'REDIRECT'
});